import { CheckCircleOutline } from "@mui/icons-material";
import { Alert } from "@mui/material";
import { useAppSelector } from "../../app/hooks";
import { selectImportPhotoDayFile } from "../../app/slices/photoDayImportSlice";

interface IProps {
    eventId : string;
  }

function PhotoDayImportResult({ eventId }: IProps){

    const photoDayStatus = useAppSelector(selectImportPhotoDayFile);

    return(
        <>
        {photoDayStatus?.isPhotoDayEvent === true &&
        (<Alert icon={<CheckCircleOutline fontSize="inherit" />} severity="success">
         <b>Status:</b>  {photoDayStatus?.status}
         <br />
         <b>Message:</b> { photoDayStatus?.message}
        </Alert> ) }
        
        {photoDayStatus?.isPhotoDayEvent === false &&
        (<Alert icon={<CheckCircleOutline fontSize="inherit" />} severity="success">
        {eventId + ' is not a Photo Day Event'}.
       </Alert>)
        }
        </>
    )
}

export default PhotoDayImportResult;